import React, { useState } from "react";

import { Box, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";

import { colors } from "@/theme/overrides/colors";

import CookingMethodInstruction from "./CookingMethodInstruction";
import { Instruction } from "../store/Instruction";
import { useRecipe } from "../store/RecipeStore";

const CookingMethodForm: React.FC = () => {
  const recipe = useRecipe();
  const [instruction] = useState(new Instruction());

  return (
    <Box display="flex" flexDirection="column" width="100%" flex={1}>
      <Box mb={6}>
        <Typography
          fontWeight={700}
          fontSize={18}
          lineHeight={1}
          color={colors.dark}
          p={4}
        >
          Cooking Instructions
        </Typography>
      </Box>

      <Box display="flex" flexDirection="column" width="100%" p={4} pt={0}>
        {recipe.instructions.map((instruction, index) => (
          <CookingMethodInstruction.Edit
            // Using id as `key` prop, since moving will change index.
            key={instruction.id}
            index={index}
            // Don't use `move` from FieldArray, its buggy, reporting
            // nonexistent errors. We'll do it ourselves.
            onMove={recipe.moveInstructionPosition}
            onRemove={recipe.removeInstruction}
          />
        ))}
        <CookingMethodInstruction.Add
          text={instruction.text !== "" ? instruction.text : ""}
          onChange={(value) => instruction.setText(value)}
          onAdd={() => {
            recipe.addInstruction(instruction);
            instruction.reset();
          }}
        />
      </Box>
    </Box>
  );
};

export default observer(CookingMethodForm);
